module.exports = __webpack_public_path__ + "bb69e79576980e97343a2440de829b4f.svg";